module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_4.121ebb856c31d105cf76d86133973428.png";